import submit from "./submit";

/**
 * Get cookie value by name.
 * @param {*} name
 */

function getCookie(name) {
  var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) {
    return match[2];
  }
  return "";
}

const invoke = (data) =>
  new Promise((resolve, reject) => {
    const emissaryReferral = getCookie("emissary_referral");
    const utm_source = getCookie("utm_source");
    const utm_campaign = getCookie("utm_campaign");
    const utm_medium = getCookie("utm_medium");

    const leadData = {
      ...data,
      emissaryReferral,
      utm_source,
      utm_campaign,
      utm_medium,
    };

    submit(leadData)
      .then((res) => {
        if (window.analytics) {
          window.analytics.identify({
            utm_campaign,
            utm_source,
            utm_medium,
          });
          window.analytics.track("Lead Form Submitted");
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export default invoke;
